import ApiService from "common/service/api";

export default class WsDeviceService extends ApiService {
  constructor(config) {
    super(config);
    this.baseURL = `/api/meters`;
  }

  getById(deviceId) {
    return this.fetchResource(`/${deviceId}`);
  }
}